<!--
 * @Author: yindengli
 * @Date: 2023-09-26 16:11:40
 * @LastEditTime: 2023-10-17 15:00:07
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\login\codeVerify.vue
-->
<template>
  <div class="">
    <div class="item phone">
      <div class="title">手机号</div>
      <a-input class="input-item" v-model="phoneValue" placeholder="请输入注册手机号" />
    </div>
    <code-item ref="codeItem" :codeUrl="CODEURL"/>
    <div class="item input-code">
      <div class="title">验证码</div>
      <a-input
        placeholder="请输入6位验证码"
        size="large"
        v-model="phoneCode"
        class="input-item"
      >
      </a-input>
      <a-button type="primary" :loading="isSending" class="code-btn" @click="getPhoneCode" >{{(sendTime !== 0 && isSending) ? sendTime : ''}}{{enterButton}}</a-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import codeItem from './code-item.vue';

import BASEURL from '../../../config/openseeyon'

export default {
  components: { codeItem },
  data() {
    return {
      phoneValue: "", // 手机输入
      phoneCode: "", // 手机收到的验证码
      CODEURL: BASEURL.baseUrl + "/seeyon/system/v2/getCaptcha",
      isSending: false, // 验证码发送中
      sendTime: 60,
      enterButton: "获取验证码",
      interval: null, // 60秒定时器
    }
  },
  methods: {
    // 手机号登录发送验证码
    getPhoneCode() {
      if (this.isSending) {
        return;
      }
      
      const codeValue = this.$refs.codeItem && this.$refs.codeItem.getCodeValue();
      const data = {
        mobile: this.phoneValue,
        type: 1,
        imgCode: codeValue.graphValue,
        imgCodeKey: codeValue.codeKey
      };

      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      axios.post(BASEURL.baseUrl + "/seeyon/userInfo/v2/phoneLoginOpenSendMobileCode", qs.stringify(data))
      .then(res => {
				if (res && res.data && res.data.success) {
          // 已发送验证码
          this.codeSending();
        } else {
          if (res && res.data) {
            this.$message.error(res.data.message);
          } else {
            this.$message.error("发送验证码失败");
          }
        }
			}).catch(() => {
        this.$message.error("发送验证码失败");
      });
    },
    getCodeVerifyValue() {
      const codeValue = this.$refs.codeItem && this.$refs.codeItem.getCodeValue();
      const data = {
        mobile: this.phoneValue,
        phoneCode: this.phoneCode,
        key: codeValue.codeKey,
        code: codeValue.graphValue
      };

      return data;
    },
    /**
     * 手机验证码发送中
     */
    codeSending() {
      this.isSending = true;
      this.enterButton = "重新获取";
      this.interval = setInterval(() => {
        if (this.sendTime == 0) {
          this.isSending = false;
          this.enterButton = "获取验证码";
          if (this.interval) {
            clearInterval(this.interval);
          }
        } else {
          this.sendTime --;
        }
        
      }, 1000);
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 100%;
}
.title {
  width: 80px;
  max-width: 80px;
  min-width: 80px;
  line-height: 52px;
  display: block;
  float: left;
  font-size: 16px;
  text-align: right;
  padding-right: 4px;
}
.input-item {
  border: 1px solid #d7d7d7;
  background: #f7f7f7;
  padding: 0 15px;
  line-height: 48px;
  height: 50px;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.code-btn {
  width: 200px;
  border: none;
  color: #fff;
  background-color: #40a9ff;
  border-color: #40a9ff;
  border-radius: 2px;
  height: 50px;
  cursor: pointer;
}

@media screen and (max-width: 1024px) {
  .input-item {
    height: 40px;
  }
  .code-btn {
    height: 40px;
  }
  .title {
    font-size: 14px;
    max-width: 60px;
    min-width: 60px;
    line-height: 40px;
    text-align: right;
    padding-right: 3px;
  }
  .img-code {
    width: 60px;
    height: 20px;
  }
  .sx-link {
    width: 40px;
    height: 25px;
  }
}
</style>